angular.module('dpw.services')
    .factory('productFilterService', ['menuService', function (menuService) {
        var RINGCENTRAL_NAME = 'RingCentral';

        var _states = {
            partnerOptions: [],
            productFamilyOptions: [],
            regionOptions: [],
            productStore: {}
        };

        Object.defineProperties(_states, {
            selectedPartner: {
                get: function () {
                    var productFilterState = menuService.getProductFilterState();
                    return productFilterState.partner;
                }
            },
            selectedProductFamily: {
                get: function () {
                    var productFilterState = menuService.getProductFilterState();
                    return productFilterState.productFamily;
                }
            },
            selectedRegions: {
                get: function () {
                    var productFilterState = menuService.getProductFilterState();
                    return productFilterState.regions;
                }
            }
        });

        var _utils = {
            updatePartnerOptions: function () {
                var partnerOptions = _.map(_states.productStore, function (partnerItem) {
                    return partnerItem.partnerName;
                });

                var sortedPartnerOptions = partnerOptions
                    .filter(function (name) {
                        return name !== RINGCENTRAL_NAME;
                    })
                    .sort(function (a, b) {
                        return a.localeCompare(b);
                    });

                sortedPartnerOptions.unshift(RINGCENTRAL_NAME);

                _states.partnerOptions = sortedPartnerOptions;
                _utils.onPartnerOptionsUpdated();
            },
            updateProductFamilyOptions: function () {
                var partnerItem = menuService.getPartnerItem(_states.productStore, _states.selectedPartner);

                if (partnerItem) {
                    _states.productFamilyOptions = _.map(partnerItem.productFamilies, function (item) {
                        return item.familyName;
                    });

                    _utils.onProductFamilyOptionsUpdated();
                    return;
                }

                _states.productFamilyOptions = [];
                _utils.onProductFamilyOptionsUpdated();
            },
            updateRegionOptions: function () {
                var productFamilyItem = menuService.getProductFamilyItem(
                    _states.productStore,
                    _states.selectedPartner,
                    _states.selectedProductFamily
                );

                if (productFamilyItem) {
                    _states.regionOptions = _utils.buildRegionOptions(productFamilyItem.products);
                    _utils.onRegionOptionsUpdated();
                    return;
                }

                _states.regionOptions = [];
                _utils.onRegionOptionsUpdated();
            },
            buildRegionOptions: function (products) {
                var regionLabels = _.reduce(products, function (allRegions, product) {
                    var regionsSupported = product.regionsSupported;
                    allRegions = allRegions.concat(regionsSupported);
                    return _.uniq(allRegions);
                }, []);

                return regionLabels.map(function (label) {
                    return {
                        label: label,
                        checked: false
                    };
                });
            },
            onPartnerStateChanged: function () {
                _utils.updateProductFamilyOptions();
                _utils.updateRegionOptions();
            },
            onProductFamilyStateChanged: function () {
                _utils.updateRegionOptions();
            },
            onPartnerOptionsUpdated: function () {
                var defaultOption = _states.partnerOptions[0];
                service.updateFilterState({
                    partner: defaultOption
                });
            },
            onProductFamilyOptionsUpdated: function () {
                var defaultOption = _states.productFamilyOptions[0];
                service.updateFilterState({
                    productFamily: defaultOption
                });
            },
            onRegionOptionsUpdated: function () {
                service.updateFilterState({
                    regions: []
                });
            }
        };

        var service = {
            init: function () {
                menuService.getProductStore().then(function (productStore) {
                    _states.productStore = productStore;
                    _utils.updatePartnerOptions();
                    _utils.updateProductFamilyOptions();
                    _utils.updateRegionOptions();
                });
            },

            updateFilterState: function (changeSet) {
                var newPartner = _.get(changeSet, 'partner');
                var newProductFamily = _.get(changeSet, 'productFamily');
                var isPartnerChanged = newPartner && (newPartner !== _states.selectedPartner);
                var isProductFamilyChanged = newProductFamily && (newProductFamily !== _states.selectedProductFamily);

                var originalState = menuService.getProductFilterState();
                var newState = _.assign({}, originalState, changeSet);

                menuService.updateProductFilterState(newState);

                if (isPartnerChanged) {
                    _utils.onPartnerStateChanged();
                }

                if (isProductFamilyChanged) {
                    _utils.onProductFamilyStateChanged();
                }
            },

            getProductFamilyOptions: function () {
                return _states.productFamilyOptions;
            },

            getRegionOptions: function () {
                return _states.regionOptions;
            },

            getPartnerOptions: function () {
                return _states.partnerOptions;
            },

            getSelectedPartner: function () {
                return _states.selectedPartner;
            },

            getSelectedProductFamily: function () {
                return _states.selectedProductFamily;
            },

            getSelectedRegions: function () {
                return _states.selectedRegions;
            }
        };

        return service;
    }]);
